import * as UserStoreModules from './userStore';
import userStore from './userStore';

export type UserData = UserStoreModules.UserData;

export default userStore;
